import { gql, TypedDocumentNode } from "@apollo/client";

import { EffectiveTerragruntVersionResult, QueryTerragruntEffectiveVersionArgs } from "types/generated";

type CheckTerragruntVersionData = {
  terragruntEffectiveVersion: Pick<
    EffectiveTerragruntVersionResult,
    "effectiveTerragruntVersion" | "effectiveTerraformVersion"
  >;
};

export const CHECK_TERRAGRUNT_VERSION: TypedDocumentNode<
  CheckTerragruntVersionData,
  QueryTerragruntEffectiveVersionArgs
> = gql`
  query CheckTerragruntVersion(
    $terragruntConstraints: String!
    $terraformConstraints: String!
    $tool: TerragruntTool
  ) {
    terragruntEffectiveVersion(
      terragruntConstraints: $terragruntConstraints
      terraformConstraints: $terraformConstraints
      tool: $tool
    ) {
      effectiveTerragruntVersion
      effectiveTerraformVersion
    }
  }
`;
